module.exports = __webpack_public_path__ + "static/bg02-b58ecc063d7e0b8df6bb9cd065f541aa.jpg";